import { PLATFORMS } from '@amzn/journeys-common';
import type { HerotatorFlavor } from '../types';

/**
 * Determines if a flavor has multiple image map areas
 * Mobile flavors don't support image map
 * Returns true if multiple image map areas are present
 */
export const flavorHasMultipleImageMapAreas = (flavor: HerotatorFlavor): boolean => {
  if (flavor.content.platform !== PLATFORMS.DESKTOP || !flavor.content.areas) return false;
  return flavor.content.areas.length > 1;
};
